export default function posts(posts = [], action) {
  switch (action.type) {
    case "DELETE": //removes selected post
      return posts.filter((post) => post._id === action.payload);

    case "LIKE":
    case "UPDATE": //returns changed post
      return posts.map((post) =>
        post._id === action.payload._id ? action.payload : post
      );
    case "FETCH_ALL": //retrieves all posts posts
      return action.payload;
    case "CREATE":
      return [...posts, action.payload];
    default:
      return posts;
  }
}
